module.exports = __webpack_public_path__ + "static/media/ios.22cef08a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ios.png
// module id = 130
// module chunks = 0